import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { OperationalLog } from '../model/OperationalLog';
import { DatePipe } from '@angular/common';

@Injectable()
export class OperationalLogFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;
    private _datePipe: DatePipe;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string, datePipe: DatePipe) {
        this._urlBase = baseUrl;
        this._httpClient = http;
        this._datePipe = datePipe
    }

    GetByTypeDate(moduleId: number, startDate: Date, endDate: Date): Observable<RequestResponse<OperationalLog[]>> {
        let startDateJson = this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ss', 'local');
        let endDateJson = this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ss', 'local');
        return this._httpClient.get<RequestResponse<OperationalLog[]>>(
            this._urlBase + 'api/OperationalLog/ByTypeDate?moduleId=' + moduleId + '&startDate=' + startDateJson + '&endDate=' + endDateJson);
    }
}
